import { DEFAULT_DURATIONS } from './constants'

export const isCustomEventDuration = (duration) => !DEFAULT_DURATIONS.includes(duration)

export const getInitialCustomDuration = (isCustom, duration) => {
  if (!isCustom) return ''

  return duration % 60 === 0
    ? (duration / 60).toString()
    : duration.toString()
}

export const getDurationInitialValues = (eventType) => {
  if (!eventType) {
    return {}
  }

  const {
    has_events: hasEvents,
    kind: eventTypeKind,
    duration,
    duration_options: durationOptions,
    duration_in_minutes: durationInMinutes,
    event_type_lock: eventTypeLock,
  } = eventType

  const eventDuration = durationInMinutes || duration
  const lockingRules = eventTypeLock
    ? eventTypeLock.locking_rules
    : []

  const isCustomDuration = isCustomEventDuration(eventDuration)

  return {
    durationOptions: durationOptions || [],
    eventDuration: !isCustomDuration ? eventDuration : 'custom',
    customEventDuration: getInitialCustomDuration(isCustomDuration, eventDuration),
    customEventDurationType: isCustomDuration && eventDuration % 60 === 0 ? 'hours' : 'minutes',
    isCustomDurationOpen: false,
    tempCustomEventDuration: '',
    tempCustomEventDurationType: 'minutes',
    lockingRules,
    hasEvents,
    eventTypeKind,
  }
}
